import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import { IOffers } from '../../types/redux/offers';
import { TProps } from '../../types/redux/props';
import { ISeoData } from '../../types/redux/seoData';
import { fetchComparison } from './fetchComparison';
import { TCompareType } from '../../types/compareType';

export interface ICompare {
  notFoundUrl: string;
  ids: number[];
  props: Partial<TProps>;
  offers: IOffers;
  seoData: ISeoData;
}

export interface IDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
}

export interface IParameters {
  compareType: TCompareType;
}

export async function resolveCompare(
  dependencies: IDependencies,
  parameters: IParameters = { compareType: 'default' },
): Promise<ICompare> {
  const { httpApi, logger } = dependencies;

  try {
    const { notFoundUrl, props, offers, ids, seoData } = await fetchComparison({ httpApi, parameters });

    return { notFoundUrl, props, offers, ids, seoData };
  } catch (error) {
    logger.error('Error at fetchComparison', {
      message: error.message,
    });

    throw error;
  }
}
